import { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

import { useDispatch, useSelector } from "react-redux";
import { checkAuthenticated } from "../../actions/auth";
import { load_actives_list } from "../../actions/management_content";
import {
  delete_transaction_from_id,
  edit_transaction_from_id,
  load_transaction_by_id,
  upload_transaction,
} from "../../actions/payment_management";
import PricecFieldTransacModal from "../../components/PricecFieldTransacModal";
import { truncateFilename } from "../../hooks/utils";
import { hasPermission } from "../../hooks/userPermissions";

const initialTransactionData = {
  profile: "",
  transaction_type: "ingreso",
  entity_name: "",
  active_type: "service",
  payment_type: "efectivo",
  active_category: "",
  amount: 1,
  price: "",
  custom_price: true,
  details: "",
};
const initialTransactionFile = {
  file: null,
  name: "",
};
const TransactionModal = (props) => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const { show, onHide, transactionId } = props;
  const [transactionData, setTransactionData] = useState(
    initialTransactionData
  );
  const [transactionFile, setTransactionFile] = useState(
    initialTransactionFile
  );
  const [activesList, setActivesList] = useState({
    service: [],
    product: [],
    rent: [],
    bank: [],
    salary: [],
    other: [],
  });
  const [optionName, setOptionName] = useState("service");
  const [formAlerts, setFormAlerts] = useState({
    transaction_type: false,
    entity_name: false,
    active_type: false,
    price: false,
  });

  const checkEmptyFields = (keyList) => {
    let isEmpty = false;
    const newFormData = { ...transactionData };
    keyList.forEach((key) => {
      if (transactionData[key].toString().trim() === "") {
        formAlerts[key] = true;
        isEmpty = true;
      } else {
        formAlerts[key] = false;
      }

      setTimeout(() => {
        setFormAlerts({
          transaction_type: false,
          entity_name: false,
          price: false,
          active_type: false,
        });
      }, 3500);
    });

    setTransactionData(newFormData);
    return isEmpty;
  };
  const fetchActivesList = async () => {
    const data = await load_actives_list();
    if (data) {
      setActivesList({ ...activesList, ...data });
    }
  };
  const fetchTransactionData = async () => {
    const data = await load_transaction_by_id(transactionId);
    if (data) {
      if (data.file) {
        const file_name_arr = data.file ? data.file.split("/") : [];
        const file_name = file_name_arr[file_name_arr.length - 1];
        const { file, ...restData } = data;
        setTransactionData({
          ...restData,
          file_name: truncateFilename(file_name, 30),
        });
      } else {
        setTransactionData(data);
      }
    }
  };

  // Handle functions
  const handleChange = (e, path) => {
    setTransactionData((prevTransactionData) => {
      return { ...prevTransactionData, [path]: e.target.value };
    });
  };
  const handleFileChange = (event) => {
    if (event.target.files.length > 0) {
      const file_name = truncateFilename(event.target.files[0].name, 30);
      setTransactionFile({
        file: event.target.files[0],
        name: file_name,
      });
      setTransactionData({
        ...transactionData,
        file_name: file_name,
      });
    } else {
      setTransactionFile(initialTransactionFile);
    }
  };

  const handleTypeChange = (e) => {
    setOptionName(e.target.value);
    setTransactionData({ ...transactionData, active_type: e.target.value });
  };

  const handleSubmit = async () => {
    dispatch(checkAuthenticated());
    if (
      !checkEmptyFields([
        "transaction_type",
        "entity_name",
        "active_type",
        "price",
      ])
    ) {
      await upload_transaction(transactionData, transactionFile);

      setTransactionData(initialTransactionData);
      setTransactionFile(initialTransactionFile);
      onHide();
    }
  };
  const handleDelete = async () => {
    dispatch(checkAuthenticated());
    await delete_transaction_from_id(transactionId);

    setTransactionData(initialTransactionData);
    setTransactionFile(initialTransactionFile);
    onHide();
  };
  const handleUploadEdit = async () => {
    dispatch(checkAuthenticated());

    if (
      !checkEmptyFields([
        "transaction_type",
        "entity_name",
        "active_type",
        "price",
      ])
    ) {
      await edit_transaction_from_id(
        transactionId,
        transactionData,
        transactionFile
      );

      setTransactionData({
        ...initialTransactionData,
        price: transactionData.price,
      });
      setTransactionFile([]);
      onHide();
    }
  };

  // MicroComponents
  const submitButtons = {
    create: () => (
      <Button variant="primary" onClick={handleSubmit}>
        Agregar
      </Button>
    ),
    edit: () => (
      <Button variant="primary" onClick={handleUploadEdit}>
        Guardar Cambios
      </Button>
    ),
  };

  // UseEffects
  useEffect(() => {
    fetchActivesList();
    const fetchData = async () => {
      if (transactionId) {
        await fetchTransactionData();
      } else {
        setTransactionData({
          ...initialTransactionData,
          active_category:
            activesList[optionName].length > 0
              ? activesList[optionName][0].id
              : "",
        });
        setTransactionFile(initialTransactionFile);
      }
    };

    fetchData();
  }, [show]);
  useEffect(() => {
    setTransactionData({
      ...transactionData,
      active_category: activesList[transactionData.active_type]?.[0]?.id,
    });
  }, [transactionData.active_type, activesList]);
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header className="justify-content-center">
        <Modal.Title>
          {transactionId ? "Editar Transaccion" : "Nueva Transaccion"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex justify-content-between align-items-center">
          {transactionId && <strong>Fecha: {transactionData.created}</strong>}
          {transactionId && <strong>Id transaccion: {transactionId}</strong>}
        </div>
        <div className="transaction-modal-body d-flex flex-column gap-2">
          <div className="input-field flex-fill">
            <label htmlFor="nameFormControlInput" className="form-label">
              Ingreso o Egreso
              <strong className="text-danger">*</strong>
              <span
                className={
                  formAlerts.transaction_type
                    ? "fst-italic m-2 text-danger"
                    : "d-none"
                }
              >
                No valido.
              </span>
            </label>
            <div className="d-flex  gap-2">
              <div className="form-check flex-fill">
                <input
                  className="form-check-input"
                  type="radio"
                  name="inlineRadioOptions"
                  id="inlineRadio1"
                  checked={transactionData.transaction_type === "ingreso"}
                  onChange={(e) => {
                    setTransactionData({
                      ...transactionData,
                      transaction_type: "ingreso",
                    });
                  }}
                />
                <label className="form-check-label" htmlFor="inlineRadio1">
                  Ingreso
                </label>
              </div>
              <div className="form-check flex-fill">
                <input
                  className="form-check-input"
                  type="radio"
                  name="inlineRadioOptions"
                  id="inlineRadio2"
                  checked={transactionData.transaction_type === "egreso"}
                  onChange={(e) => {
                    setTransactionData({
                      ...transactionData,
                      transaction_type: "egreso",
                    });
                  }}
                />
                <label className="form-check-label" htmlFor="inlineRadio2">
                  Egreso
                </label>
              </div>
            </div>
          </div>
          <div className="input-field flex-fill">
            <label htmlFor="nameFormControlInput" className="form-label">
              Nombre Entidad/Persona
              <strong className="text-danger">*</strong>
              <span
                className={
                  formAlerts.entity_name
                    ? "fst-italic m-2 text-danger"
                    : "d-none"
                }
              >
                No valido.
              </span>
            </label>
            <input
              type="text"
              className={
                formAlerts.entity_name
                  ? "border border-danger form-control"
                  : "form-control"
              }
              id="nameFormControlInput"
              value={transactionData.entity_name}
              onChange={(e) => handleChange(e, "entity_name")}
            />
          </div>
          <div className="d-flex flex-column gap-2">
            <div className="row">
              <div className="col input-field">
                <label htmlFor="rutFormControlInput" className="form-label">
                  Tipo de Activo
                  <strong className="text-danger">*</strong>
                </label>
                <select
                  className={
                    formAlerts.name
                      ? "border border-danger form-select w-auto"
                      : "form-select w-auto"
                  }
                  aria-label="Default select example"
                  name="active_type"
                  value={transactionData.active_type}
                  onChange={(e) => handleTypeChange(e)}
                >
                  <option value="service">Servicio</option>
                  <option value="product">Producto</option>
                  <option value="rent">Arriendo</option>
                  <option value="bank">Banco</option>
                  <option value="salary">Remuneración</option>
                  <option value="other">Otro</option>
                </select>
              </div>

              <div className="col input-field">
                <label
                  htmlFor="first_lastnameFormControlInput"
                  className="form-label"
                >
                  Categoria
                </label>
                <select
                  className="form-select category-select"
                  aria-label="Default select example"
                  name="active_category"
                  value={transactionData.active_category}
                  onChange={(e) => handleChange(e, "active_category")}
                >
                  {activesList[transactionData.active_type]?.map((item) => (
                    <option value={item.id} key={item.id}>
                      {item.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="row">
              <div className="col input-field">
                <label htmlFor="rutFormControlInput" className="form-label">
                  Medio de Pago
                  <strong className="text-danger">*</strong>
                </label>
                <select
                  className={
                    formAlerts.name
                      ? "border border-danger form-select w-auto"
                      : "form-select w-auto"
                  }
                  aria-label="Default select example"
                  name="active_type"
                  value={transactionData.payment_type}
                  onChange={(e) => handleChange(e, "payment_type")}
                >
                  <option value="efectivo">Efectivo</option>
                  <option value="transferencia">Transferencia</option>
                  <option value="credito">Crédito</option>
                  <option value="other">Otro</option>
                </select>
              </div>
              <div className="col input-field">
                <label
                  htmlFor="second_lastnameFormControlInput"
                  className="form-label"
                >
                  Cantidad
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="second_lastnameFormControlInput"
                  value={transactionData.amount}
                  onChange={(e) => handleChange(e, "amount")}
                />
              </div>
            </div>
          </div>
          <PricecFieldTransacModal
            handleChange={handleChange}
            transactionData={transactionData}
            setTransactionData={setTransactionData}
            activesList={activesList}
            alertPrice={formAlerts.price}
          />
          <div className="input-field">
            <label htmlFor="exampleFormControlTextarea1" className="form-label">
              Descripcion
            </label>
            <textarea
              className="form-control"
              id="exampleFormControlTextarea1"
              rows={3}
              onChange={(e) => handleChange(e, "details")}
              value={transactionData.details}
            />
          </div>
          <div className="input-field">
            <label htmlFor="exampleFormControlTextarea1" className="form-label">
              Archivo de Transaccion
            </label>

            <div className="file-input-group input-group">
              <div className="files-container flex-fill p-2">
                {transactionFile.name && (
                  <span className="badge text-bg-secondary d-flex gap-2 p-2 align-items-center">
                    {transactionFile.name}
                  </span>
                )}
              </div>
              <input
                className="form-control d-none"
                type="file"
                id="inpuTransFile"
                onChange={(e) => handleFileChange(e)}
              />
              <button
                className="btn btn-outline-secondary"
                type="button"
                onClick={() => document.getElementById("inpuTransFile").click()}
              >
                Subir Archivo
              </button>
            </div>
            <div className="d-flex gap-2 p-2">
              Archivo existente:
              {transactionData.file_name ? (
                <span className="badge text-bg-secondary d-flex gap-2 p-2 align-items-center">
                  {transactionData.file_name}
                  <i
                    className="bi bi-x-circle fs-6"
                    onClick={() =>
                      setTransactionData({
                        ...transactionData,
                        file_name: "",
                      })
                    }
                  />
                </span>
              ) : (
                <span className="badge text-bg-secondary">Ninguno</span>
              )}
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="justify-content-between">
        {transactionId && hasPermission(user, "delete:transaction") && (
          <Button variant="danger" onClick={handleDelete}>
            Eliminar
          </Button>
        )}
        <div className="d-flex flex-fill justify-content-end gap-2">
          <Button variant="secondary" onClick={onHide}>
            Cerrar
          </Button>
          {transactionId
            ? hasPermission(user, "update:transaction") && submitButtons.edit()
            : hasPermission(user, "create:transaction") && submitButtons.create()
          }
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default TransactionModal;
